import React from 'react';
import {List, ListItem, ListItemButton, ListItemText, Stack} from '@mui/material';

import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {Loading} from 'presentation/components/Loading/Loading';
import {useChatLinks} from 'presentation/pages/private/help/components/ChatsModal/hooks/useChatLinks';
import {
	StyledDialogContent,
	StyledIconIllustration,
	StyledListItemIcon,
	StyledText,
} from './styles';
import {ChatsModalContentProps} from './types';

const {modal} = translations['pt-br'].privateFlow.help.contactUs;

export function ChatsModalContent({teaFormProps}: ChatsModalContentProps) {
	const {chatLinks, isLoading} = useChatLinks({teaFormProps});
	const lastChatLinkIndex = chatLinks.length - 1;

	return (
		<StyledDialogContent>
			<Stack gap={2} flex={1}>
				<StyledIconIllustration variant="primary" customIconName="chat-filled" />
				<StyledText variant="h6">{modal.subtitle}</StyledText>
				<StyledText variant="body1">{modal.description}</StyledText>

				<List disablePadding>
					{chatLinks.map((chat, index) => (
						<ListItem
							disablePadding
							divider={index !== lastChatLinkIndex}
							key={chat.title}>
							<ListItemButton
								disableRipple
								disableTouchRipple
								disabled={isLoading}
								sx={{p: '8px 0'}}
								onClick={chat.onClick}>
								<ListItemText
									primary={chat.title}
									slotProps={{primary: {fontWeight: 600}}}
									secondary={chat.description}
								/>
								<StyledListItemIcon>
									{chat.isLoading ? (
										<Loading size={16} color="inherit" />
									) : (
										<Icon name="arrow-right-filled" />
									)}
								</StyledListItemIcon>
							</ListItemButton>
						</ListItem>
					))}
				</List>
			</Stack>
		</StyledDialogContent>
	);
}
